import { OnboardingTab } from "app/profile/models/onboarding.model"
import { PayloadAction } from "app/shared/model/action.model";

export const Get_Task_Step_State = 'Get_Task_Step_State';
export class GetTaskStepState implements PayloadAction {
  readonly type = Get_Task_Step_State;
  constructor(public supplierCode: string, public taskId: number, public taskType: OnboardingTab, public forceReload: boolean) { }
}


export const Get_Supplier_Task_Step_State_Success = 'Get_Supplier_Task_Step_State_Success';
export class GetSupplierTaskStepsStateSuccess implements PayloadAction {
  readonly type = Get_Supplier_Task_Step_State_Success;
  constructor(public payload) {
  }
}

export type SupplierTasksActions = GetTaskStepState | GetSupplierTaskStepsStateSuccess;
